import React from 'react';
import 'react-dom';
import '../../_rollupPluginBabelHelpers-2e5b701d.js';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import '../../index-930c2100.js';
import '../../hooks/useActivify.js';
import '../../index-efb29065.js';
import '../../key_codes-a5a2b85e.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import '../../style-inject.es-1f59c1d0.js';
import '@styled-system/layout';
import '@styled-system/flexbox';
import '@styled-system/position';
import '@styled-system/shadow';
import '../box.js';
import { g as getObjectValue } from '../../util-cc00ee1d.js';
import '../../index.esm-f8e9e79f.js';
import '@styled-system/grid';
import '@styled-system/background';
import { I as IconWrapper } from '../../IconWrapper-eb05d1ed.js';

var Warning = function Warning(props) {
  return /*#__PURE__*/React.createElement(IconWrapper, props, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47768 2 2 6.47768 2 12C2 17.5223 6.47768 22 12 22C17.5223 22 22 17.5223 22 12C22 6.47768 17.5223 2 12 2ZM12 20.3036C7.41518 20.3036 3.69643 16.5848 3.69643 12C3.69643 7.41518 7.41518 3.69643 12 3.69643C16.5848 3.69643 20.3036 7.41518 20.3036 12C20.3036 16.5848 16.5848 20.3036 12 20.3036Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.yellow.neon),
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.yellow.neon),
    strokeWidth: "0.416667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9286 15.9286C10.9286 16.2127 11.0415 16.4853 11.2425 16.6862C11.4434 16.8871 11.7159 17 12.0001 17C12.2842 17 12.5568 16.8871 12.7577 16.6862C12.9586 16.4853 13.0715 16.2127 13.0715 15.9286C13.0715 15.6444 12.9586 15.3719 12.7577 15.171C12.5568 14.97 12.2842 14.8571 12.0001 14.8571C11.7159 14.8571 11.4434 14.97 11.2425 15.171C11.0415 15.3719 10.9286 15.6444 10.9286 15.9286ZM11.4644 13.4286H12.5358C12.634 13.4286 12.7144 13.3482 12.7144 13.25V7.17857C12.7144 7.08036 12.634 7 12.5358 7H11.4644C11.3661 7 11.2858 7.08036 11.2858 7.17857V13.25C11.2858 13.3482 11.3661 13.4286 11.4644 13.4286Z",
    fill: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.yellow.neon),
    stroke: getObjectValue(props.theme.colors, props.iconColor, props.theme.colors.yellow.neon),
    strokeWidth: "0.416667"
  })));
};
Warning.propTypes = {
  iconColor: PropTypes.string
};
Warning.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Warning",
  "props": {
    "iconColor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
var WarningIcon = withTheme(Warning);

export default WarningIcon;
